/**
 * EventRegistrationSection — the phone's stand-in for the rail card's window.
 *
 * Hidden above 901px by eventDetail.css, which is the complement of the rule
 * that hides the rail below it: exactly one of the two is ever on screen, so
 * the dates are never printed twice.
 */

import React from 'react';
import RegistrationWindow from './RegistrationWindow';

export default function EventRegistrationSection({
  opensAt, closesAt, places, timezone,
  registrationType, registrationRequired, externalUrl,
}) {
  return (
    <section className="evb-sec evb-regsec">
      <h2 className="evb-h">Registration</h2>
      <RegistrationWindow
        opensAt={opensAt}
        closesAt={closesAt}
        places={places}
        registrationType={registrationType}
        registrationRequired={registrationRequired}
        externalUrl={externalUrl}
      />
      <p className="evb-note">All times are local to the event — {timezone}.</p>
    </section>
  );
}
